import React, { Component } from 'react';

import * as defaultConst from '../../../../../utils/clientConstant';
import commonUtil from '../../../../../utils/commonUtil';
import serverClientUtil from '../../../../../utils/serverClientUtil';

const applicationRoutes = commonUtil.getApplicationRoutes();

class OtherGiftTables extends Component {
  constructor(props) {
    super(props);
    const pathId = commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: this.props.eventId });
    this.lpGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.LP) + pathId;
    this.wsGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WS) + pathId;
    this.pbGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PB) + pathId;
    this.gapGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.GAP) + pathId;
    this.pbkGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PBK) + pathId;
    this.weGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WLM) + pathId;
    this.truGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.TRU) + pathId;
  }

  render() {
    return (
      <div className="otherGiftTables">
        <p className="otherList">Más listas de regalos en:</p>
        <div className="otherStores">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={this.lpGRURL}
            className={this.props.getDisplayStyle(defaultConst.constBrand.LP)}
          >
            <img src={commonUtil.getAssetURL() + '/images/admin/lvLogo.png'} alt="Liverpool" /></a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={this.wsGRURL}
            className={this.props.getDisplayStyle(defaultConst.constBrand.WS)}
          >
            <img src={commonUtil.getAssetURL() + '/images/admin/wsLogo.png'} alt="Williams Sonoma" /></a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={this.pbGRURL}
            className={this.props.getDisplayStyle(defaultConst.constBrand.PB)}
          >
            <img src={commonUtil.getAssetURL() + '/images/admin/pbLogo.png'} alt="Potery Barn" /> </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={this.pbkGRURL}
            className={this.props.getDisplayStyle(defaultConst.constBrand.PBK)}
          >
            <img src={commonUtil.getAssetURL() + '/images/admin/pbkLogo.png'} alt="Potery Barn Kids" /> </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={this.gapGRURL}
            className={this.props.getDisplayStyle(defaultConst.constBrand.GAP)}
          >
            <img src={commonUtil.getAssetURL() + '/images/admin/gapLogo.png'} alt="Potery Barn Teen" /></a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={this.weGRURL}
            className={this.props.getDisplayStyle(defaultConst.constBrand.WLM)}
          >
            <img src={commonUtil.getAssetURL() + '/images/admin/whLogo.png'} alt="West Elm" />
          </a>
          {
            serverClientUtil.enableIconToys &&
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={this.truGRURL}
              className={this.props.getDisplayStyle(defaultConst.constBrand.TRU)}
            >
              <img style={{ width: '38px' }} src={commonUtil.getAssetURL() + '/images/admin/toysLogo.png'} alt="Toys R Us" />
            </a>
          }
        </div>
      </div>
    );
  }
}

export default OtherGiftTables;
